module.exports = __webpack_public_path__ + "static/media/revolveNameHorizontal.76beb441.png";